module.exports = __webpack_public_path__ + "static/mask_lo_122-7a8dfcaadecc5477b1a86c35dbda4bfe.jpg";